import IconBase from "./IconBase";

// A calendar with a marked day.
const DateIcon = (props) => (
    <IconBase {...props}>
        <rect x="3" y="5" width="18" height="16" rx="3" />
        <path d="M8 2.5V6" />
        <path d="M16 2.5V6" />
        <path d="M3 10h18" />
        <circle cx="8.5" cy="14.5" r="1.1" fill="currentColor" stroke="none" />
    </IconBase>
);

export default DateIcon;
